<template>
  <div class="top-tab" id="top-tab" :data-color="activeColor">
    <div class="tab-left" id="tab-left-main">
      <div class="tab" id="tab-main">
        <div class="item" v-for="(item,index) in tab" :key="index" :class="{'item-selected':item.active}"
          @click="clickTab(item,index)" @contextmenu.prevent="rightClick(item,index,$event)">
          <md-icon :class="{'tabIcon-active': item.active}" :md-src="'/static/svg/icon/icon-tab.svg'"></md-icon>
          <!-- <md-icon v-if="!item.icon" :md-src="'/static/svg/'+item.parentIcon+'.svg'"></md-icon> -->
          <span class="item-name"> {{ item.name }}</span>
          <div class="close" v-if="index!==0" @click.stop="removeTab(item,index)">×</div>
        </div>
        <ul class="right-contextMenu" v-show="rightContextMenu.show"
          :style="{left:rightContextMenu.style.left+'px',top:rightContextMenu.style.top+'px'}">
          <li @click="closeAllTab">关闭所有选项</li>
          <li @click="closeOtherTab">关闭其他选项</li>
        </ul>
        <!-- <div class="item-tip" v-show="mousePosition.show&&a" :style="mousePosition.style">
          <span>{{ mousePosition.showText }}</span></div> -->
        <div class="down" id="down">
          <el-popover width="164" trigger="click" popper-class="top-more-menu" :visible-arrow="false"
            v-model="showTab2">
            <ul class="more">
              <li v-for="(item,index) in tab2" @click="clickTab2(item,index)" :key="index"
                :class="{'route-active':isActive(item)}">
                <span class="gou">√</span>
                <span class="name">{{ item.name }}</span>
                <span class="close" @click.stop="removeTab2(item,index)">×</span>
              </li>
              <li class="fg" v-show="this.tab2.length>0"></li>
              <li @click="closeCurrentTab">关闭当前选项</li>
              <li @click="closeAllTab">关闭所有选项</li>
              <li @click="closeOtherTab">关闭其他选项</li>
            </ul>
            <img slot="reference" src="../../assets/svg/k-menu/down2.svg" />
          </el-popover>
        </div>
      </div>
    </div>
    <div class="tab-toolbar">
      <!-- <div class="menu-com-list">
        <li class="md-list-item">
          <a href="javascript:void(0)" class="md-list-item-router md-list-item-container md-button-clean dropdown">
            <div class="md-list-item-content">
              <k-btn slot="title" class="md-button md-simple" data-functype="POPUP" :small-size="true">
                <svg-icon icon-class="notice" width="12px" height="12px"></svg-icon>
              </k-btn>
            </div>
          </a>
        </li>
      </div> -->
      <div class="menu-com-list">
        <li class="md-list-item">
          <a class="md-list-item-router md-list-item-container md-button-clean dropdown">
            <div class="md-list-item-content">
              <drop-down direction="down" toggle-type="click">
                <k-btn slot="title" class="md-button md-simple md-theme-default" :small-size="true"
                  data-toggle="dropdown">{{username}}
                  <svg-icon icon-class="drop-down" width="10px" height="10px"></svg-icon>
                </k-btn>
                <ul class="dropdown-menu dropdown-menu-left">
                  <li @click="popEditUserInfor">
                    <a> <span class="el-icon-s-custom" style="margin-right: 8px;"></span>个人信息</a>
                  </li>
                  <li @click="popChangePwd">
                    <a> <span class="el-icon-unlock" style="margin-right: 8px;"></span> 修改密码</a>
                  </li>
                  <li @click="loginOut">
                    <a> <span class="el-icon-s-opportunity" style="margin-right: 8px;"></span> 安全退出</a>
                  </li>
                </ul>
              </drop-down>
            </div>
          </a>
        </li>
      </div>
    </div>

    <!--    修改用户弹出框   -->
    <k-popup ref="editUserPopup" data-title="用户信息" data-type="drawer" :data-append-to-body="true">
      <k-form ref="editUserForm" :data-col="1">
        <k-form-item label="登录名">
          <k-field-text v-model="formData.loginname" data-disabled :data-clearable="false" />
        </k-form-item>
        <k-form-item label="用户名称">
          <k-field-text v-model="formData.username" data-disabled :data-clearable="false" />
        </k-form-item>
        <k-form-item label="电话号码">
          <k-field-text v-model="formData.mobileno" data-disabled :data-clearable="false" />
        </k-form-item>
        <k-form-item label="电子邮件">
          <k-field-text v-model="formData.email" data-disabled :data-clearable="false" />
        </k-form-item>
        <k-form-item label="性别">
          <k-field-text v-model="formData.sex" data-disabled :data-clearable="false" />
        </k-form-item>
      </k-form>
    </k-popup>


    <k-popup ref="resetPwdPopup" data-title="修改密码" data-type="drawer" :data-append-to-body="true">
      <k-form ref="resetPwdForm" :data-col="1">
        <k-form-item label="原密码">
          <k-field-text v-model="pwdData.oldPwd" data-show-password :dataAllowblank="false" />
        </k-form-item>
        <k-form-item label="新密码">
          <k-field-text v-model="pwdData.newPwd" data-show-password :dataAllowblank="false" data-regx="^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d]{8,}$" data-regx-text="长度8位以上，包含数字和字母"/>
        </k-form-item>
        <k-form-item label="确认密码">
          <k-field-text v-model="pwdData.confirmNewPwd" data-show-password :dataAllowblank="false" data-regx="^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d]{8,}$" data-regx-text="长度8位以上，包含数字和字母"/>
        </k-form-item>
        <k-form-footer data-align="center">
          <k-btn class="btn-primary btn-border" data-size="small" data-functype="SUBMIT"
            data-action="User.resetPwdCheckOldPwd" :data-model="pwdData" :data-handler="resetPwdHandler"
            data-form="resetPwdForm" data-target="userGrid">确定
          </k-btn>
          <k-btn class="btn-info btn-border" data-size="small" data-functype="CLOSE">取消</k-btn>
        </k-form-footer>
      </k-form>
    </k-popup>
  </div>
</template>

<script>
import auth from "../../utils/auth";
import MD5 from "@/frame/md5.js"
import Tools from "@/utils/tools";
import { mapMutations } from 'vuex';

export default {
  name: "TopTab",
  props: {
    activeColor: {
      type: String,
      default: "orange",
    }
  },
  data() {
    return {
      currentIndex: 0,
      showTab2: false,
      showClose: false,
      allMenus: [],
      rightContextMenu: {
        show: false,
        style: {
          left: "0px",
          top: "0px"
        },
      },
      mousePosition: {
        time: 0,
        show: false,
        showText: "",
        style: {
          left: "0px",
          top: "0px"
        },
      },
      a: false,
      timer: null,
      tabState: {
        oldTime: 0,
        time: 0
      },
      formData: {
        loginname: ""
      },
      pwdData: {},
      offsetData: {   // 获取宽度（兼容微前端）
        _tab: 0,
        _left: 0
      }
    }
  },
  computed: {
    tab() {
      let tabs;
      let data = this.$store.state.system.tab;
      tabs = typeof data === 'string' ? JSON.parse(data) : data;
      tabs[0]['icon'] = "home"
      return tabs;
    },
    tab2() {
      let tabs;
      let data = this.$store.state.system.tab2;
      tabs = typeof data === 'string' ? JSON.parse(data) : data;
      return tabs;
    },
    microRouter() {
      return this.$store.state.micro.microRouter;
    },
    username() {
      return localStorage.getItem("username")
    }
  },
  watch: {
    microRouter(to) {
      let flag = false;     // true 已存在    false 需要新增
      for (let i = 0; i < this.tab.length; i++) {
        if (this.tab[i].path === to.path) {
          flag = true;
          this.$store.commit("system/setTabActive", { index: i, active: true });
        } else {
          this.$store.commit("system/setTabActive", { index: i, active: false });
        }
      }

      // for (let i = 0; i < this.tab2.length; i++) {
      //   if (this.tab2[i].path === to.path) {
      //     flag = true;
      //     let index = this.tab.length - 1
      //     this.$store.commit("system/setTab2Push", this.tab[index]);
      //     this.$nextTick(() => {
      //       this.$store.commit("system/setTabSplice", {index: index, count: 1});
      //       this.$store.commit("system/setTabPush", this.tab2[i]);
      //       this.$store.commit("system/setTab2Splice", {index: i, count: 1});
      //       this.$store.commit("system/setTabActive", {index: index, active: true});
      //       this.$forceUpdate()
      //     })
      //   } else {
      //     this.$store.commit("system/setTab2Active", {index: i, active: false});
      //   }
      // }

      if (!flag) {
        let data = {
          path: to.path,
          name: to.menuname,
          url: to.url,
          // query: to.query,
          active: true,
          // meta: to.meta
          father: to.father,    // 子应用名称
          fatherId: to.fatherId,    // 子应用id
        };
        // 特殊处理 monitor(skyWalking)子应用
        if (to.url == 'general') {
          data.father = "monitor"
          data.module = "monitor"
        }



        // router-view 中的Keep-alive缓存设置
        // if (to.meta.notKeepAlive && to.meta.notKeepAlive === true) {
        //   this.setExInclude(data, 1)
        // } else {
        //   this.setExInclude(data, 2)
        // }
        this.$store.commit("system/setTabPush", data);

        this.$nextTick(() => {
          this.setTopTab()
        })
        // setTimeout(() => {this.setTopTab()}, 0)
      }
    },
    '$route': function (to, oldTo) {     // 专门兼容不在子应用的界面（首页）
      let whiteList = ['/main/desktop']
      if (whiteList.includes(to.fullPath)) {
        for (let i = 0; i < this.tab.length; i++) {
          if (this.tab[i].path === '/main/desktop') {
            this.$store.commit("system/setTabActive", { index: i, active: true });
          } else {
            this.$store.commit("system/setTabActive", { index: i, active: false });
          }
        }
      }
    },
    rightContextMenu: {
      handler(val) {
        if (val.show) {
          document.body.addEventListener('click', this.closeContextMenu)
        } else {
          document.body.removeEventListener('click', this.closeContextMenu)
        }
      },
      deep: true
    }
  },
  created() {
    this.httpUtil.ajaxJson({
      url: "sys/findMenus.json"
    }).then(data => {
      this.setAllMenus(data.rows)
    });
  },
  mounted() {
    this.offsetData._tab = document.getElementById("tab-main")
    this.offsetData._left = document.getElementById("tab-left-main")
    window.onresize = () => {
      this.offsetData._tab = document.getElementById("tab-main")
      this.offsetData._left = document.getElementById("tab-left-main")
      this.setTopTab()
    }
  },
  methods: {
    ...mapMutations(['SET_MICROROUTER', 'SET_SHOWAPP']),
    rightClick(tab, index, el) {
      this.clickTab(tab, index)
      if (index === 0) {
        return
      }
      this.rightContextMenu.style.left = el.clientX
      this.rightContextMenu.style.top = el.clientY
      this.rightContextMenu.show = true
    },
    closeContextMenu() {
      this.rightContextMenu.show = false
    },
    setAllMenus(arr, parentIcon) {
      arr.forEach((item) => {
        if (parentIcon) {
          item["parentIcon"] = parentIcon
        }
        this.allMenus.push(item)
        if (item.children) {
          this.setAllMenus(item.children, item.icon)
        }
      })
    },
    isActive(item) {
      if (item.path === this.$route.path && JSON.stringify(item.query) === JSON.stringify(this.$route.query)) {
        return true
      } else {
        return false
      }
    },
    jupFunc(tab) {
      if (tab.path.includes('desktop')) {    // 主应用路由，正常跳转
        // console.log('主应用内跳转');
        this.$router.push({
          path: tab.path,
          query: tab.query
        });
      } else {
        const { father } = tab;
        const { path } = this.$route;
        if ((path.indexOf(father) == -1)) {
          // 路由不一致， 切换子组件根路径，再进行跳转
          // console.log('切换子应用');
          tab.module = father
          this.SET_SHOWAPP(tab)
          this.$router.push({ name: father, params: tab })
        } else {
          // 跳转子应用对应的路由
          // console.log('应用内jup');
          this.SET_MICROROUTER(tab)
        }
      }
    },
    clickTab(tab, index) {
      this.jupFunc(tab)
      if (tab.active) {
        this.tabState.oldTime = this.tabState.time
        this.tabState.time = new Date().getTime()
        if ((this.tabState.time - this.tabState.oldTime) < 400 && index !== 0) {
          this.removeTab(tab, index)
        }
        return
      }
    },
    clickTab2(tab, index) {
      this.$store.commit("system/setTab2Splice", { index: index, count: 1 });
      this.$store.commit("system/setTabPush", tab);
      this.$nextTick(() => {
        this.setTopTab()
      })
      this.jupFunc(tab)
      this.showTab2 = false
    },
    closeCurrentTab() {
      if (this.tab.length === 1) {
        return
      }
      if(this.$route.path === '/main/desktop') {
        return
      }

      this.tab.forEach((item, index) => {
        if (item.active) {
          this.removeTab(item, index)
        }
      })

      this.tab2.forEach((item, index) => {
        if (item.active) {
          this.removeTab2(item, index)
        }
      })
      this.showTab2 = false
    },
    closeAllTab() {
      if (this.tab.length == 1) {
        return
      }

      // this.tab.forEach((item, index) => {
      //   if (index != 0) {
      //     this.setExInclude(item, 1)
      //   }
      // })

      // this.tab2.forEach((item, index) => {
      //   this.setExInclude(item, 1)
      // })

      let newArr = []
      newArr.push(this.tab[0])
      this.$store.commit("system/setTab", newArr);
      this.$store.commit("system/setTab2", []);
      this.jupFunc(this.tab[0])
      this.showTab2 = false
    },
    closeOtherTab() {
      if (this.tab.length === 1) {
        return
      }

      let activeIndex = -1
      let istabIndex = true
      this.tab.forEach((item, index) => {
        if (item.active) {
          activeIndex = index
          istabIndex = true
        }

        // if (index !== 0 || item.active !== true) {
        //   this.setExInclude(item, 1)
        // }
      })

      this.tab2.forEach((item, index) => {
        if (item.active) {
          activeIndex = index
          istabIndex = false
        }
        // if (item.active !== true) {
        //   this.setExInclude(item, 1)
        // }
      })

      let newArr = []
      newArr.push(this.tab[0])
      if (istabIndex) {
        newArr.push(this.tab[activeIndex])
      } else {
        newArr.push(this.tab2[activeIndex])
      }

      this.$store.commit("system/setTab", newArr);
      this.$store.commit("system/setTab2", []);
      this.showTab2 = false
    },
    removeTab(tab, index) {
      this.$store.commit("system/setTabSplice", { index: index, count: 1 });
      if (tab.active) {
        this.jupFunc(this.tab[index - 1])
      }

      if (this.tab2.length > 0) {
        let deleteIndex = this.tab2.length - 1
        this.$store.commit("system/setTabPush", this.tab2[deleteIndex]);
        this.$store.commit("system/setTab2Splice", { index: deleteIndex, count: 1 });
      }
    },
    removeTab2(tab, index) {
      // this.setExInclude(tab, 1)
      this.$store.commit("system/setTab2Splice", { index: index, count: 1 });
      if (tab.active) {
        if (index !== 0) {
          this.jupFunc(this.tab2[index - 1])
          // this.$router.push(
          //   {
          //     path: this.tab2[index - 1].path,
          //     query: this.tab2[index - 1].query
          //   }
          // )
        } else {
          this.jupFunc(this.tab[this.tab.length - 1])
          // this.$router.push(
          //   {
          //     path: this.tab[this.tab.length - 1].path,
          //     query: this.tab[this.tab.length - 1].query
          //   }
          // )
        }
      }
    },
    setExInclude(tab, type) {       // 设置不缓存组件（ps. 微前端环境下,暂时关闭该功能，待解决...）
      if (tab.meta && tab.meta.componentName) {
        //设置为不缓存
        if (type === 1) {
          let e = this.$store.state.system.exincludeList
          let a = false
          e.every((item) => {
            if (item === tab.meta.componentName) {
              a = true
              return false
            } else {
              return true
            }
          })
          if (!a) {
            e.push(tab.meta.componentName)
            this.$store.commit("system/setExincludeList", e);
          }
        } else {
          //设置为缓存
          let e = this.$store.state.system.exincludeList
          let newArray = e.filter((item) => {
            return item !== tab.meta.componentName
          })
          this.$store.commit("system/setExincludeList", newArray);
        }
      }
    },
    setTopTab() {   // 设置占用位置tab1和tab2占比
      let _tab = this.offsetData._tab;
      let _left = this.offsetData._left;
      if (!_tab) {
        return;
      }
      if (!_left) {
        return;
      }
      let tab = _tab.offsetWidth || 0;
      let left = _left.offsetWidth || 0;
      if ((tab + 8) <= left) {
        if (this.tab2.length > 0 && (tab - this.tab.length * 166) > 166) {
          let index = this.tab2.length - 1
          this.$store.commit("system/setTabPush", this.tab2[index]);
          this.$store.commit("system/setTab2Splice", { index: index, count: 1 });
          this.$nextTick(() => {
            this.$forceUpdate()
          })
          // setTimeout(() => {this.$forceUpdate()},100)
        }
      } else {
        if (this.tab === undefined) {
          return;
        }
        let index = this.tab.length - 1
        while (this.tab[index].active) {
          index--;
        }
        if (index === 0) {
          return
        }
        // 判断菜单是否在tab2中
        const existIndex = this.tab2.findIndex(item => {
          return (item.name === this.tab[index].name && item.url === this.tab[index].url)
        })
        if(existIndex === -1) {
          this.$store.commit("system/setTab2Push", this.tab[index]);
          // 获取当前 active
          const activeIndex = this.tab.findIndex(item => item.active)
          const existActiceIndex = this.tab2.findIndex(item => {
            return (item.name === this.tab[activeIndex].name && item.url === this.tab[activeIndex].url)
          })
          if(existActiceIndex !== -1) {
            this.$store.commit("system/setTab2Splice", { index: existActiceIndex, count: 1 });
          }
        }
        this.$store.commit("system/setTabSplice", { index: index, count: 1 });
        this.$nextTick(() => {
          this.setTopTab()
        })
      }
    },
    getUserInfor() {
      Tools.getLoginUser().then(res => {
        this.formData.loginname = res.loginname;
        this.formData.username = res.username;
        this.formData.mobileno = res.mobileno;
        this.formData.email = res.email;
        this.formData.sex = res.sex=="0"?"男":"女";
      });
    },
    getUserPwdInfor() {
      this.pwdData = {};
      Tools.getLoginUser().then(res => {
        this.pwdData.loginname = res.loginname;
        this.pwdData.userid = res.userid;
      });
    },
    popEditUserInfor() {
      this.$refs.editUserPopup.popup();
      this.getUserInfor();
    },
    popChangePwd() {
      this.$refs.resetPwdPopup.popup();
      this.getUserPwdInfor();
    },
    resetPwdHandler(params) {
      if (params.newPwd !== params.confirmNewPwd) {
        this.$message.error("两次输入不一致！请重新输入")
        return false
      }
      params.passwd = MD5.MD5(params.loginname + params.newPwd)
      params.oldPwd = MD5.MD5(params.loginname + params.oldPwd)
      params.newPwd = {}
      params.confirmNewPwd = {}
      return true
    },
    forceUpdate() {
      this.$forceUpdate();
    },
    loginOut() {
      auth.removeToken()
      // 重置 tab
      let tabHome = this.$store.state.system.tab[0]
      tabHome.active = true
      this.$store.commit("system/setTab", [tabHome])
      this.$store.commit("system/setTab2", [])
      sessionStorage.removeItem("vuex")

      const outUrl = localStorage.getItem("outUrl");
      if(outUrl) {
        window.location.href = outUrl;
      } else {
        this.Tools.ssoOutLogin()
      }
    }
  }
}
</script>

<style lang="scss">
@import "TopTab";
</style>



// WEBPACK FOOTER //
// src/frame/main/TopTab.vue